import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import {companyDataToUpdate} from '../../../../../reduxToolkit/UpdateCompany/UpdateCompanyApi';
import {GetVCardSettings} from '../../../../../reduxToolkit/Employee/EmployeeApi';
import VCard from 'vcard-creator';

const GenerateVCardApp = ({show}) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { getSingleUserProvider } = useSelector((state) => state?.providersSlice);
    const { companyDataToUpdateObj } = useSelector((state) => state?.UpdateCompanySlice);
    const getEmployeeDetailsByUserId = useSelector((state) => state?.EmployeeSlice?.getEmployeeDetailsByUserId?.data?.user,);
    const employee = useSelector((state) => state?.EmployeeSlice?.getEmployeeDetailsByUserId?.data?.employee);
    const extraData = useSelector((state) => state?.EmployeeSlice?.getEmployeeDetailsByUserId?.data?.extraData);
    const { headersList } = useSelector((state) => state.headersSlice);
    const color = useSelector((state) => state?.EmployeeSection?.getVCardSettings?.data?.color);

    const [qrValue, setQrValue] = useState('');
    const [qrColor, setQrColor] = useState('');
    const [vCardImage, setVCardImage] = useState('');
    const [headerField, setHeaderField] = useState({});
    const [workPhone, setWorkPhone] = useState('');
    const [personalPhone, setPersonalPhone] = useState('');
    const [workFax, setWorkFax] = useState('');
    const [personalFax, setPersonalFax] = useState('');
    const [urlAddress, setUrlAddress] = useState('');
    const [street, setStreet] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [country, setCountry] = useState(null);
    const [settingsData, setSettingsData] = useState();

    const bgColor = '#ffffff';
    const qrSize = 344;
    const qrRef = useRef(null);
    useEffect(() => {
        dispatch(companyDataToUpdate());
    }, [dispatch]);

    const logoImage = companyDataToUpdateObj?.image ? `data:image/png;base64,${companyDataToUpdateObj.image}` : null;

    useEffect(() => {
        if (show) {
            dispatch(GetVCardSettings()).then(({ payload: { data, code } }) => {
                setQrColor(data.data.color);
                setVCardImage(`data:image/png;base64,${data.data.image}`);
                setSettingsData(data.data);
            });
        }
    }, [show]);

    useEffect(() => {
        if (settingsData) {
            Object.keys(settingsData).forEach((key) => {
                const value = settingsData[key];
                if (value && headerField.hasOwnProperty(value)) {
                    switch (key) {
                        case 'workPhone':
                            setWorkPhone(headerField[value] || '');
                            break;
                        case 'personalPhone':
                            setPersonalPhone(headerField[value] || '');
                            break;
                        case 'workFax':
                            setWorkFax(headerField[value] || '');
                            break;
                        case 'personalFax':
                            setPersonalFax(headerField[value] || '');
                            break;
                        case 'urlAddress':
                            setUrlAddress(headerField[value] || '');
                            break;
                        case 'street':
                            setStreet(headerField[value] || null);
                            break;
                        case 'postalCode':
                            setPostalCode(headerField[value] || null);
                            break;
                        case 'city':
                            setCity(headerField[value] || null);
                            break;
                        case 'state':
                            setState(headerField[value] || null);
                            break;
                        case 'country':
                            setCountry(headerField[value] || null);
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    }, [headerField, settingsData]);

    useEffect(() => {
        if (!headersList || !extraData) return;

        let result = {};
        for (let i = 1; i <= 15; i++) {
            const header = headersList[`header${i}`];
            const field = `field${i}`;
            if (header) {
                result[header] = (extraData && extraData[field]) || '';
            }
        }

        const cleanedData = Object.keys(result || {})
            .filter((key) => !key.startsWith('Header'))
            .reduce((obj, key) => {
                obj[key] = result[key];
                return obj;
            }, {});

        setHeaderField(cleanedData);
    }, [headersList, extraData]);

    useEffect(() => {
        if (getEmployeeDetailsByUserId) {
            const { email, name, lastName, secondLastName } = getEmployeeDetailsByUserId;
            const fullName = `${name} ${lastName} ${secondLastName}`;
            const company = companyDataToUpdateObj?.name || '';
            const jobTitle = employee?.roleName || '';
            const departmentName = employee?.departmentName || '';

            function capitalize(str) {
                if (typeof str !== 'string') return '';
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }

            const cleanedDataString = Object.keys(headerField)
                .map((key) => `${capitalize(key)}: ${headerField[key]}`)
                .join('\n');

            const address = [street || '', city || '', postalCode || '', country || ''];
            const vCard = new VCard();
            vCard.addName(fullName);
            vCard.addCompany(company);
            vCard.addJobtitle(jobTitle);
            vCard.addRole(departmentName);
            vCard.addEmail(email);
            vCard.addPhoneNumber(workPhone, 'PREF;WORK');
            vCard.addPhoneNumber(personalPhone, 'WORK');
            vCard.addURL(urlAddress);
            vCard.addAddress(...address);
            setQrValue(vCard.toString());
        }
    }, [
        getEmployeeDetailsByUserId,
        companyDataToUpdateObj,
        employee,
        headerField,
        street,
        city,
        postalCode,
        country,
        urlAddress,
    ]);

    const handleDownload = () => {
        if (qrRef.current) {
            const canvas = qrRef.current.querySelector('canvas');
            if (canvas) {
                const image = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = image;
                link.download = 'vcardall.png';
                link.click();
            }
        }
    };

    return {
        logoImage,
        t,
        dispatch,
        getSingleUserProvider,
        companyDataToUpdateObj,
        getEmployeeDetailsByUserId,
        employee,
        extraData,
        headersList,
        color,
        qrValue,
        qrColor,
        vCardImage,
        headerField,
        workPhone,
        personalPhone,
        workFax,
        personalFax,
        urlAddress,
        street,
        postalCode,
        city,
        state,
        country,
        settingsData,
        bgColor,
        qrSize,
        qrRef,
        handleDownload

    }
}


export default GenerateVCardApp;
